import React from "react";
import { useScrollEffects } from "../hooks/useScrollEffects";

const BackToTop = () => {
  const { showBackToTop, scrollToTop } = useScrollEffects();

  return (
    <button
      onClick={scrollToTop}
      className={`fixed left-auto items-center justify-center w-10 h-10 text-white duration-300 ease-in-out rounded-md shadow-md back-to-top bottom-8 right-8 z-999 bg-primary hover:bg-primary/80 ${
        showBackToTop ? "flex" : "hidden"
      }`}
      aria-label="Back to top"
    >
      <span className="mt-[6px] h-3 w-3 rotate-45 border-t border-l border-white"></span>
    </button>
  );
};

export default BackToTop;
